import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import axios from "axios";
import { toast } from "sonner";
import Loader from "../../components/common/Loader";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import { isRole, isRoleType } from "../../redux/selectors/authSelector";
import { useSelector } from "react-redux";

const ViewParent = () => {
  const { id } = useParams();
  const navigate = useCountryNavigate();
  const [loader, setLoader] = useState(true);
  const [parent, setParent] = useState(null);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  const mode = localStorage.getItem("mode");
  const schoolId = localStorage.getItem("activeSchoolId");
  useEffect(() => {
    const fetchParent = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}admin/parent/${id}`
        );

        if (res.data?.status === 200) {
          setParent(res.data.data);
        } else {
          toast.error("Parent not found");
        }
      } catch (err) {
        toast.error("Failed to fetch parent");
      } finally {
        setLoader(false);
      }
    };

    fetchParent();
  }, [id]);
  const handleParentNavigation = () => {
    if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
      if (mode === "view") {
        navigate(`admin-school/view/${schoolId}`, {
          state: { mainTab: "Parents Management" },
        });
      } else {
        navigate("navigation-dashboard", {
          state: { mainTab: "Parents Management" },
        });
      }
    } else {
      navigate("parent-management");
    }
  };
  if (loader) return <Loader isClass="loader_fullscreen" />;
  if (!parent) return null;

  return (
    <div className="p-6 space-y-6 pr-0">
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="w-full bg-white rounded-xl p-6">
          {/* Header */}
          <div
            className="flex items-center mb-6 cursor-pointer"
            onClick={handleParentNavigation}
          >
            <FiArrowLeft className="text-2xl text-gray-800 mr-2" />
            <h2 className="text-2xl font-bold text-gray-800">View Parent</h2>
          </div>

          {/* Parent Details */}
          <div className="space-y-5">
            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Parent Name
              </label>
              <input
                type="text"
                disabled
                value={parent.name}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 bg-gray-100"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                disabled
                value={parent.email}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 bg-gray-100"
              />
            </div>

            {/* Mobile */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Mobile Number
              </label>
              <input
                type="text"
                disabled
                value={parent.mobile_number}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 bg-gray-100"
              />
            </div>

            {/* Children */}
            <div className="space-y-4">
              <label className="block text-sm font-medium text-gray-700">
                Children Details
              </label>

              {parent.children.map((child, index) => (
                <div
                  key={index}
                  className="border border-gray-300 rounded-lg p-4 bg-gray-50"
                >
                  <h3 className="font-medium mb-3">Child {index + 1}</h3>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <input
                      disabled
                      value={child.name}
                      className="border rounded-lg p-2 bg-gray-100"
                      placeholder="Name"
                    />
                    <input
                      disabled
                      value={child.class}
                      className="border rounded-lg p-2 bg-gray-100"
                      placeholder="Class"
                    />
                    <input
                      disabled
                      value={child.section}
                      className="border rounded-lg p-2 bg-gray-100"
                      placeholder="Section"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewParent;
